import * as React from "react";
import { formatRole } from "../../libs/user";

interface IProps {
  roles: string[];
  filter?: string[];
  filterOnMultiple?: boolean;
}

export function RoleBadge({ children }) {
  return (
    <span
      className="badge badge-default"
      style={{
        background: "rgb(50,163,202)",
        marginRight: "2px",
        marginLeft: "2px",
      }}
    >
      {children}
    </span>
  );
}

const RoleBadges = ({ roles, filter, filterOnMultiple }: IProps) => {
  const filteredRoles =
    filter && ((filterOnMultiple && roles.length > 1) || !filterOnMultiple)
      ? roles.filter(r => !filter.includes(r))
      : roles;
  const formattedRoles = formatRole(filteredRoles);
  return Array.isArray(formattedRoles) ? (
    <div>
      {formattedRoles.map(r => (
        <RoleBadge key={r}>{r}</RoleBadge>
      ))}
    </div>
  ) : null;
};

export default RoleBadges;



// WEBPACK FOOTER //
// ./app/javascript/components/core/RoleBadges.tsx